export const UPDATA_PERSON_HOUSE_DATA = 'personMainPage/UPDATA_PERSON_HOUSE_DATA';
const initialState = {
    personHouseData:{
        isRecord:false,
        ListingPropertyRecord:{
            feeds:[]
        },
        DeletedPropertyRecord:{
            feeds:[]
        }

    }
};


const personHouseDataReducer =  (personHouseData={}, action)=>{
    switch (action.type) {
        case UPDATA_PERSON_HOUSE_DATA:
            return {
                ...personHouseData,
                [action.subType]:action.data
            };
        default:
            return personHouseData
    }
}

export default (state = initialState, action) => {
    return {
        personHouseData : personHouseDataReducer(state.personHouseData, action)
    };
}

export const dispatch_func = {
    updata_personHouseData : (data,type) => {
        return dispatch => {
            dispatch({
                type: UPDATA_PERSON_HOUSE_DATA,
                data:data,
                subType:type
            });
        }
    },


};


// WEBPACK FOOTER //
// ./src/modules/personHousePage.js